import React from 'react';

import './feedback.css'
import { LargeButton } from './LargeButton';


export function FeedbackButton(props: {}) {
    return (
        <LargeButton
            href="https://docs.google.com/forms/d/e/1FAIpQLSeiAPWlkm5fVGH7MI8CwAqNtAAdVzdAmhi32JkVmKvs8VWs4Q/viewform"
            className="feedbackContainer"
            line1="Ask Questions"
            line2="Send Feedback"
        />
    )
}